<p-message
    [dt]="pMessageScopedToken"
    severity="info"
    class="text-center"
    styleClass="w-full !rounded-none">
    <ng-template #container>
        <div
            class="flex min-h-8 w-full items-center justify-center bg-[var(--p-blue-200)] px-2 text-sm font-medium leading-normal text-[var(--p-surface-700)]">
            <div>
                <span class="font-bold" aria-hidden="true">🌼 </span>
                <span class="font-semibold">Group Sessions are now live!</span>
                <span aria-hidden="true"> · </span>
                <button
                    type="button"
                    class="cursor-pointer underline underline-offset-2 hover:no-underline"
                    (click)="onClickLearnMore()">
                    Learn more
                </button>
            </div>
        </div>
    </ng-template>
</p-message>
